// extracted by mini-css-extract-plugin
export default {"form":"case-form_form__xppvf","containerField":"case-form_containerField__dlqRx","errorMessage":"case-form_errorMessage__+VSpK","center":"case-form_center__jecAo"};